import { render, staticRenderFns } from "./GCompetencyDistribution.vue?vue&type=template&id=013103f6&"
import script from "./GCompetencyDistribution.vue?vue&type=script&lang=ts&"
export * from "./GCompetencyDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports